import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import {GaTrackingEventLabel, GaTrackingEventName, GATrackingEventType} from '../../constants';
import { ApplicationSuggestionSelectedEventType } from '~shared/modules/application-event/constants';

export class GATrackingSearchSuggestion implements GATrackingEvent {

  constructor(private suggestionType: ApplicationSuggestionSelectedEventType, private suggestionValue: string) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.SearchSuggestion;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.SearchSuggestion,
      label: this.getLabel()
    };
  }

  private getLabel(): string {
    let label: string;
    let suggestionValue = this.suggestionValue;
    switch (this.suggestionType) {
      case ApplicationSuggestionSelectedEventType.AllPromoSuggestionSelected:
        label = GaTrackingEventLabel.SuggestedPromotionPage;
        suggestionValue = null;
        break;
      case ApplicationSuggestionSelectedEventType.CategorySuggestionSelected:
        label = GaTrackingEventLabel.SuggestedCategory;
        break;
      case ApplicationSuggestionSelectedEventType.HistorySuggestionSelected:
        label = GaTrackingEventLabel.SearchHistory;
        break;
      case ApplicationSuggestionSelectedEventType.PromoSuggestionSelected:
        label = GaTrackingEventLabel.SuggestedProduct;
        break;
      case ApplicationSuggestionSelectedEventType.TextSuggestionSelected:
        label = GaTrackingEventLabel.SuggestedKeyword;
        break;
    }

    if (!suggestionValue) {
      return label;
    }

    return `${label} --> ${suggestionValue.toLowerCase()}`;
  }
}
